import { GET_DMX_PROFILES, GET_DMX_PROFILES_SUCCESS, GET_DMX_PROFILES_ERROR } from './actionTypes';

export const getDmxProfiles = (user, deviceType) => {
  return {
    type: GET_DMX_PROFILES,
    payload: { user, deviceType },
  };
};

export const getDmxProfilesSuccess = (profiles) => {
  return {
    type: GET_DMX_PROFILES_SUCCESS,
    payload: { profiles },
  };
};

export const getDmxProfilesError = (error) => {
  return {
    type: GET_DMX_PROFILES_ERROR,
    payload: error,
  };
};
